import React from 'react';//inititiating react app
import ReactDom from 'react-dom';//init reactdom from react

import App from './App'

ReactDom.render(<App/>, document.querySelector('#root')); //targeting root in index.html 
